import { render } from "./AddDiscoveryModal2.vue?vue&type=template&id=8592e6dc&scoped=true"
import script from "./AddDiscoveryModal2.vue?vue&type=script&lang=js"
export * from "./AddDiscoveryModal2.vue?vue&type=script&lang=js"

import "./AddDiscoveryModal2.vue?vue&type=style&index=0&id=8592e6dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8592e6dc"]])

export default __exports__